<div class="my-3 grid-2col gap">
    <p-card [header]="'files.categories' | translate">
        @let data = selectableCategories();
        @if (data?.length) {
            <div class="folders-container">
                @for (item of data; track $index) {
                    <app-folder
                        [name]="item.name"
                        [selected]="item.selected"
                        [count]="item.filesCount"
                        (selectedChange)="onCategory($event, item.id)"
                    ></app-folder>
                }
            </div>
        }
    </p-card>
    <app-file-upload-box class="flex-grow-1" (onSelect)="onSelected($event)" #files></app-file-upload-box>
</div>

<app-table
    [showSearch]="true"
    [showDelete]="true"
    translatePrefix="files."
    [columns]="columns"
    [gridData]="store2.data.getFiles()"
    [refreshCallback]="store2.api.getFiles"
    [additionalFilter]="additionalFilter()"
    (deleteCallback)="onDelete($event)"
    [defaultSorters]="[{ column: 'id', direction: 'DESC' }]"
    [hideCheckboxes]="true"
    [showClearFilter]="false"
>
    <ng-template let-item="item" pTemplate="download">
        @if (item.categoryCode !== DefaultCategoryTypeEnum.CERTIFICATES) {
            <app-button [text]="true" styleClass="shareIcon" icon="pi-download"
                (clickEvent)="download(item)"></app-button>
        }
    </ng-template>
    <ng-template let-item="item" pTemplate="share">
        @if (item.categoryCode !== DefaultCategoryTypeEnum.CERTIFICATES) {
            <app-button [text]="true" styleClass="shareIcon" icon="pi-share-alt"
                (clickEvent)="onShare($event, item)"></app-button>
        }
    </ng-template>
    <ng-template let-data="data" pTemplate="kind">
        {{ data && 'inputs.document.' + data | translate }}
    </ng-template>
    <ng-template let-data="data" pTemplate="date">
        {{ data | localDate : 'dd.MM.yyyy' }}
    </ng-template>
    <ng-template let-data="data" pTemplate="size">
        {{ data | formatSize }}
    </ng-template>
    <ng-template let-item="item" pTemplate="accessCount">
            <span [style.cursor]="'pointer'"
                (click)="onDownloadCount($event, item)">{{ item.accessCount | number: '1.0-0' : 'cs-CZ' }}×</span>
    </ng-template>
</app-table>
